import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';

export const apiWordpress = axios.create({
  baseURL: window.location.href.split('/wp-admin')[0],
});

export const getWpnonce = async () => {
  const response = await axios.get(
    `${window.location.href.split('/wp-admin')[0]}/wp-admin/admin-ajax.php?action=generate_nonce`
  );
  if (response?.status == 200) return response?.data?.data?.nonce;
  else return null;
};

apiWordpress.interceptors.request.use(
  async function (config) {
    config.headers['wpnonce'] = await getWpnonce();
    return config;
  },
  function (error) {
    return error;
  }
);

export const useAcaoWpGet = action => {
  return useQuery(
    ['action', action],
    async () => {
      const { data } = await apiWordpress.get(`/wp-admin/admin-ajax.php?action=${action}`);
      return data;
    },
    {
      retry: false,
    }
  );
};

export const useAction = () => {
  return useMutation(async action => {
    const { data } = await apiWordpress.get(`/wp-admin/admin-ajax.php?action=${action}`);
    return data;
  });
};

export const useActionToken = () => {
  return useMutation(
    async () => {
      const { data } = await apiWordpress.get(`/wp-admin/admin-ajax.php?action=get_token_opti`);
      return data?.data;
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'action_token',
        });
      },
    }
  );
};

export const useSaveUserOpti = () => {
  return useMutation(
    async data => {
      const response = await apiWordpress.post(`/wp-admin/admin-ajax.php?action=${data.action}`, {
        idUsuarioWordpress: data.idUsuarioWordpress,
        idUsuarioOpti: data.idUsuarioOpti,
        login: data.login,
        password: data.password,
      });
      return response.data;
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'action_save_user_opti',
        });
      },
    }
  );
};

export const useActionParam = () => {
  return useMutation(
    async data => {
      const response = await apiWordpress.post(
        `/wp-admin/admin-ajax.php?action=${data?.action}`,
        data?.param
      );

      return response.data;
    },
    {
      retry: false,
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'action_param',
        });
      },
    }
  );
};

export const useSaveArticleOpti = () => {
  return useMutation(
    async data => {
      const response = await apiWordpress.post(`/wp-admin/admin-ajax.php?action=${data?.action}`, {
        postId: data.postId,
        article: data?.article,
      });

      return response.data;
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'action_save_article_opti',
        });
      },
    }
  );
};

export const useFetchYoastSEOFocusKeyword = () => {
  return useMutation(
    async () => {
      const response = await apiWordpress.get(
        `/wp-admin/admin-ajax.php?action=get_yoast_seo_focuskw`
      );
      return response.data;
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'action_fetch_yoast_SEO_focusKeyword',
        });
      },
    }
  );
};
